import {IInitiatorDetails, initInitiatorDetails} from "./InitiatorDetails";
import {initRequestPOIInfoItem, RequestPOIInfoItem} from "./RequestPOIInfoItem";
import {EUSectoralLegislatureBasisDto, RecipientAndRequestDto} from "./RecipientAndRequestDto";

export interface INewRequestForInfoItem {
    id: number,
    statusTypeId: number,
    initiatorDetails: IInitiatorDetails;
    personOfInterest: RequestPOIInfoItem;
    recipientAndRequestDetails: RecipientAndRequestDto[],
    euSectoralLegislatureBasis: EUSectoralLegislatureBasisDto[]
}

export interface INewRequestForInfoItemError {
    statusCode: number
}

export function initNewRequestForInfoItem(): INewRequestForInfoItem {
    return {
        id: 0,
        statusTypeId: 0,
        initiatorDetails: initInitiatorDetails(),
        personOfInterest: initRequestPOIInfoItem(),
        recipientAndRequestDetails: [],
        euSectoralLegislatureBasis: []
    };
}
